import { render } from "./ModalScontiLogistici.vue?vue&type=template&id=e6fd1224"
import script from "./ModalScontiLogistici.vue?vue&type=script&lang=js"
export * from "./ModalScontiLogistici.vue?vue&type=script&lang=js"

import "./ModalScontiLogistici.vue?vue&type=style&index=0&id=e6fd1224&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__